/**
* DevExpress Analytics (widgets\filtereditor\helpers\_helper.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localization_utils_1 = require("../../../property-grid/localization/localization_utils");
function initDisplayText(object) {
    object.displayText = localization_utils_1.getLocalization(object.name, object.localizationId);
}
exports.initDisplayText = initDisplayText;
